var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "gallery-display" },
    [
      _c(
        "aNewCarousel",
        {
          ref: "main",
          staticClass: "main-carousel",
          attrs: {
            "as-nav-for": _vm.asNavFor1,
            options: _vm.mainSliderOptions,
          },
        },
        [
          _c("template", { attrs: { type: "div" }, slot: "prevButton" }, [
            _c(
              "svg",
              {
                staticClass: "icon",
                staticStyle: { "enable-background": "new 0 0 50 50" },
                attrs: {
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  x: "0px",
                  y: "0px",
                  viewBox: "0 0 50 50",
                  "xml:space": "preserve",
                },
              },
              [
                _c("line", {
                  staticClass: "ls",
                  attrs: { x1: "16.618", y1: "25", x2: "33.382", y2: "7.895" },
                }),
                _vm._v(" "),
                _c("line", {
                  staticClass: "ls",
                  attrs: { x1: "16.618", y1: "25", x2: "33.382", y2: "42.105" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "template",
            {
              attrs: {
                title: "Next Slide",
                alt: "Next Slide",
                "aria-label": "Next Slide",
              },
              slot: "nextButton",
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "7.895",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "42.105",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.media, function (slide, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "slide feature-slide",
                class: `slide--${index}`,
              },
              [
                slide.type === "youtube"
                  ? [
                      _c(
                        "b-btn",
                        {
                          staticClass: "play",
                          attrs: { title: "Play Video" },
                          on: {
                            click: function ($event) {
                              return _vm.triggerVideoModal(slide)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "play-icon" }, [
                            _c(
                              "svg",
                              {
                                staticClass: "icon",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 16.021 18.193",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M0,9.1V1A1,1,0,0,1,1.5.135L8.511,4.183l7.01,4.048a1,1,0,0,1,0,1.732L8.511,14.01,1.5,18.058A1,1,0,0,1,0,17.192Z",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("AImage", {
                  staticClass: "feature-image display-image",
                  attrs: {
                    img: slide.image,
                    preset: _vm.getPreset(slide.image),
                    ratio: _vm.getRatio(slide.image),
                    tag: "img",
                    cover: "",
                  },
                }),
              ],
              2
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "aNewCarousel",
        {
          ref: "thumbnails",
          staticClass: "navigation-carousel",
          attrs: {
            "as-nav-for": _vm.asNavFor2,
            options: _vm.thumbnailSliderOptions,
          },
        },
        [
          _c("template", { attrs: { type: "div" }, slot: "prevButton" }, [
            _c(
              "svg",
              {
                staticClass: "icon",
                staticStyle: { "enable-background": "new 0 0 50 50" },
                attrs: {
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  x: "0px",
                  y: "0px",
                  viewBox: "0 0 50 50",
                  "xml:space": "preserve",
                },
              },
              [
                _c("line", {
                  staticClass: "ls",
                  attrs: { x1: "16.618", y1: "25", x2: "33.382", y2: "7.895" },
                }),
                _vm._v(" "),
                _c("line", {
                  staticClass: "ls",
                  attrs: { x1: "16.618", y1: "25", x2: "33.382", y2: "42.105" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "template",
            {
              attrs: {
                title: "Next Slide",
                alt: "Next Slide",
                "aria-label": "Next Slide",
              },
              slot: "nextButton",
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "7.895",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "42.105",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.media, function (slide, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "slide slide-thumbnail",
                class: `slide--${index}`,
                on: {
                  click: function ($event) {
                    return _vm.$refs.thumbnails.goTo(index)
                  },
                },
              },
              [
                _c("AImage", {
                  staticClass: "thumb-image",
                  attrs: {
                    img: slide.image,
                    preset: _vm.getPreset(slide.image),
                    ratio: _vm.getRatio(slide.image),
                    tag: "img",
                    cover: "",
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("videoModal", {
        ref: "galleryVideoModal",
        attrs: { src: _vm.modalVideo.src },
        on: { videoModalHidden: _vm.videoModalHidden },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }